import type { ReactNode } from "react";
import { useAppSelector } from "redux/hooks";
import { selectAuthenticated } from "redux/authSlice";
import TourRuntime from "./TourRuntime";

interface TourProviderProps {
  children: ReactNode;
}

const TourProvider = ({ children }: TourProviderProps) => {
  const isAuthenticated = useAppSelector(selectAuthenticated);

  if (!isAuthenticated) return <>{children}</>;

  return <TourRuntime>{children}</TourRuntime>;
};

export default TourProvider;
